module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35c338ca60869c6e4d21ac52cfce8e69.png";